import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { FieldPath, FormProvider, useForm } from 'react-hook-form';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { ICompanyViewModel } from '../../../view-models/company.view-model';
import { CompanyListsOverviewPanel } from '../../CompanyProfiles2/Summary/CompanyListsOverviewPanel';
import { DummyCompanyId } from './DummyData';
import { EditSectionOverlay } from './EditSectionOverlay';
import { useLoadSelectedListOverviewFieldsFields } from './data-display-utils';

export function EditConfigsLoader() {
  const { loaded: loadedDigestFields, selectedFields: selectedDigestFields } =
    useLoadSelectedListOverviewFieldsFields();

  if (!loadedDigestFields) {
    return null;
  }

  return (
    <>
      <EditListsDisplayConfigs overviewFieldsToShow={selectedDigestFields!} />
    </>
  );
}
export interface IEditListsDisplayConfigsProps {
  overviewFieldsToShow: FieldPath<ICompanyViewModel>[];
}

export function EditListsDisplayConfigs({ overviewFieldsToShow }: IEditListsDisplayConfigsProps) {
  const navigate = useNavigate();

  const methods = useForm({});

  const onEditDetails = useCallback(() => {
    navigate(`./${ROUTES.COMPANY_LIST_OVERVIEW}`);
  }, [navigate]);

  return (
    <>
      <EditSectionOverlay onEdit={onEditDetails} title='Company Overview'>
        <FormProvider {...methods}>
          <CompanyListsOverviewPanel
            companyId={DummyCompanyId}
            editable={false}
            fieldsToShow={overviewFieldsToShow}
          />
        </FormProvider>
      </EditSectionOverlay>
    </>
  );
}
